var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SspLayout',{attrs:{"area":"core"}},[_c('div',{staticClass:"col-sm-12"},[_c('ActivateForValidation',{model:{value:(_vm.activation),callback:function ($$v) {_vm.activation=$$v},expression:"activation"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5a18638","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/core/order/ActivateOrder.vue
// module id = null
// module chunks = 